export type LegalSection = {
  heading: string
  paragraphs: string[]
}

export type LegalDocument = {
  id: 'privacidad' | 'terminos'
  linkLabel: string
  title: string
  intro: string
  sections: LegalSection[]
}

export const legalDocuments: LegalDocument[] = [
  {
    id: 'privacidad',
    linkLabel: 'Política de Privacidad',
    title: 'Política de Privacidad',
    intro:
      'Esta política explica qué información recogemos cuando usted visita esta página o adquiere el Protocolo de Inflamación Silenciosa, y cómo la usamos.',
    sections: [
      {
        heading: '1. Información que recogemos',
        paragraphs: [
          'Cuando usted realiza una compra, recogemos únicamente los datos necesarios para entregarle el producto digital: su nombre y su correo electrónico.',
          'Los datos de su tarjeta o método de pago son procesados directamente por la plataforma de pago y nunca son almacenados en nuestros servidores.',
        ],
      },
      {
        heading: '2. Cómo usamos su información',
        paragraphs: [
          'Usamos su correo electrónico para enviarle el acceso a su material, sus actualizaciones y, si usted lo autoriza, consejos relacionados con el protocolo.',
          'No vendemos, alquilamos ni intercambiamos su información personal con terceros con fines publicitarios.',
        ],
      },
      {
        heading: '3. Cookies y medición',
        paragraphs: [
          'Esta página puede usar cookies y herramientas de medición para entender cómo se navega el sitio y mejorar la experiencia de lectura. Usted puede desactivar las cookies desde la configuración de su navegador en cualquier momento.',
        ],
      },
      {
        heading: '4. Seguridad de los datos',
        paragraphs: [
          'Todas las transacciones se realizan mediante conexiones cifradas. Aplicamos medidas razonables para proteger su información contra accesos no autorizados.',
        ],
      },
      {
        heading: '5. Sus derechos',
        paragraphs: [
          'Usted puede solicitar en cualquier momento acceder a sus datos, corregirlos o pedir que sean eliminados de nuestros registros, así como darse de baja de nuestros correos con un solo clic al final de cada mensaje.',
        ],
      },
      {
        heading: '6. Cambios en esta política',
        paragraphs: [
          'Podemos actualizar esta política para reflejar mejoras en nuestros procesos o cambios en la normativa aplicable. La versión vigente será siempre la publicada en esta página.',
        ],
      },
    ],
  },
  {
    id: 'terminos',
    linkLabel: 'Términos y Condiciones',
    title: 'Términos y Condiciones',
    intro:
      'Al adquirir el Protocolo de Inflamación Silenciosa usted acepta los siguientes términos de uso del material digital.',
    sections: [
      {
        heading: '1. Naturaleza del producto',
        paragraphs: [
          'El Protocolo de Inflamación Silenciosa es un producto 100% digital. No se envía ningún material físico. El acceso se entrega de forma inmediata después de confirmarse el pago.',
        ],
      },
      {
        heading: '2. Pago único',
        paragraphs: [
          'El precio corresponde a un pago único, sin suscripciones, sin cargos recurrentes y sin renovaciones automáticas.',
        ],
      },
      {
        heading: '3. Uso personal y licencia',
        paragraphs: [
          'Su compra le otorga una licencia personal e intransferible para leer y aplicar el contenido. No está permitido copiar, revender, distribuir ni publicar el material, total o parcialmente, sin autorización escrita.',
        ],
      },
      {
        heading: '4. Aviso de salud',
        paragraphs: [
          'El contenido tiene fines educativos e informativos y no constituye diagnóstico, tratamiento ni prescripción médica. No sustituye la valoración de un profesional de la salud.',
          'Antes de modificar su alimentación, sus suplementos o su rutina de movimiento, consulte a su médico, especialmente si tiene prótesis, una condición diagnosticada o toma medicación.',
        ],
      },
      {
        heading: '5. Resultados',
        paragraphs: [
          'Los resultados descritos son ilustrativos y dependen de la constancia de cada persona y de sus condiciones individuales. No garantizamos resultados idénticos para todos los casos.',
        ],
      },
      {
        heading: '6. Reembolsos',
        paragraphs: [
          'Si el material no cumple con lo prometido, usted puede solicitar el reembolso dentro de los primeros 7 días posteriores a la compra a través de la plataforma de pago utilizada.',
        ],
      },
      {
        heading: '7. Aceptación',
        paragraphs: [
          'Completar la compra implica que usted ha leído, entendido y aceptado estos términos, así como la Política de Privacidad.',
        ],
      },
    ],
  },
]
